<div class="ws-product-grid__request-card">
  <div class="ws-product-grid__request-card-inner">
    <div class="ws-product-grid__request-card-content">
      <div class="text-center">
        <div class="ws-product-grid__request-card-title"
             [innerHTML]="'orderProcess.cakesOverview.doYouMissBakeryOrProduct.title' | translate">
          Do you miss a bakery <br> or product?
        </div>

        <div [translate]="'orderProcess.cakesOverview.doYouMissBakeryOrProduct.helpText'">
          Please contact us and we will see if we can add it for you
        </div>
      </div>
    </div>
  </div>
</div>
